import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { history } from 'legacy/lut/helpers/route'
import { getProgramTypeCacheStore } from 'legacy/lut/services/partner360/configuration/helpers/getProgramTypeCacheStore'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { deleteParamsFromUrl, getUrlWithParams } from 'core-components/helpers/url'

import { CHANGE_PROGRAM_TYPE } from '../constants'
import { selectFinancialYear } from '../selectors/selectFinancialYear'
import { selectOfferingsMode } from '../selectors/selectOfferingsMode'
import { selectPartnerId } from '../selectors/selectPartnerId'

export const changeProgramType = createAsyncThunk<ProgramTypes, ProgramTypes>(
  CHANGE_PROGRAM_TYPE,
  async (programType, { getState }) => {
    const partnerId = compose(selectPartnerId, getState)()
    const isNewOfferingsMode = compose(selectOfferingsMode, getState)()
    const fYear = compose(selectFinancialYear, getState)()
    const programTypeCache = getProgramTypeCacheStore()
    const partnerIdWithMode = isNewOfferingsMode
      ? `${partnerId}_${fYear}_new`
      : `${partnerId}_${fYear}_old`

    if (programType === ProgramTypes.Summary) {
      history.push(getUrlWithParams({ summary: 'report' }))
      history.push(deleteParamsFromUrl(['ptype']))
    } else {
      history.push(getUrlWithParams({ ptype: programType }))
      history.push(deleteParamsFromUrl(['summary']))
    }

    const cachedProgramType = await programTypeCache.getById(partnerIdWithMode)
    const method = cachedProgramType !== null ? programTypeCache.update : programTypeCache.create
    await method('', [
      {
        partnerId: partnerIdWithMode,
        programType,
        fYear,
      },
    ])

    return programType
  }
)
